export default "__VITE_ASSET__eee23013__"